import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const navLinks = [{
    name: 'About',
    href: '/about'
  }, {
    name: 'Research',
    href: '/research'
  }, {
    name: 'Certification',
    href: '/certification'
  }, {
    name: 'Product Reviews',
    href: '/product-reviews'
  }, {
    name: 'Media & Insights',
    href: '/media'
  }, {
    name: 'Support Us',
    href: '/support-us'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'}`} data-id="element-1087">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1088">
        <div className="flex justify-between items-center" data-id="element-1089">
          <div className="flex-shrink-0" data-id="element-1090">
            <Link to="/" className="flex items-center" data-id="element-1091">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8HZiCJw5VjFSfFjXEXdjWt/ChatGPT_Image_Sep_14%2C_2025%2C_09_59_43_PM.png" alt="Ukweli Institute Logo" className={`h-10 md:h-12 transition-all duration-300 ${isHomePage && !scrolled ? 'brightness-0 invert' : ''}`} data-id="element-1092" />
            </Link>
          </div>
          {/* Desktop Navigation */}
          <div className="hidden md:block" data-id="element-1093">
            <div className="ml-10 flex items-center space-x-6" data-id="element-1094">
              {navLinks.map(link => <Link key={link.name} to={link.href.startsWith('/') ? link.href : '/'} href={link.href.startsWith('#') ? link.href : undefined} className={`${scrolled || !isHomePage ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-gray-200'} px-2 py-1 text-sm font-medium transition-colors duration-200`} data-id="element-1095">
                  {link.name}
                </Link>)}
            </div>
          </div>
          {/* Mobile Navigation Button */}
          <div className="flex md:hidden" data-id="element-1096">
            <button onClick={() => setIsOpen(!isOpen)} className={`${scrolled || !isHomePage ? 'text-gray-700 hover:text-gray-900' : 'text-white hover:text-gray-200'} focus:outline-none`} data-id="element-1097">
              {isOpen ? <XIcon size={24} data-id="element-1098" /> : <MenuIcon size={24} data-id="element-1099" />}
            </button>
          </div>
        </div>
        {/* Mobile Navigation Menu */}
        {isOpen && <div className="md:hidden mt-2" data-id="element-1100">
            <div className="pt-2 pb-3 space-y-1 bg-white rounded-md shadow-lg" data-id="element-1101">
              {navLinks.map(link => <Link key={link.name} to={link.href.startsWith('/') ? link.href : '/'} href={link.href.startsWith('#') ? link.href : undefined} className="block px-3 py-2 text-base font-medium text-gray-700 hover:bg-gray-50 hover:text-blue-600" onClick={() => setIsOpen(false)} data-id="element-1102">
                  {link.name}
                </Link>)}
            </div>
          </div>}
      </div>
    </nav>;
};